import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

/** In-app notifications (the topbar bell). */
@Injectable({ providedIn: 'root' })
export class NotificationService {

  constructor(private api: ApiService) {}

  /** Paginated list (10 at a time) + unread count. */
  list(page = 0, size = 10) {
    return this.api.get<any>('/api/notifications', { page, size });
  }

  /** Lightweight unread count — polled by the bell every 10s. */
  unreadCount() {
    return this.api.get<any>('/api/notifications/unread-count');
  }

  markRead(id: string) {
    return this.api.post<any>(`/api/notifications/${id}/read`, {});
  }

  markAllRead() {
    return this.api.post<any>('/api/notifications/read-all', {});
  }
}
